import { UserModel } from '../user';
import { Acceptance } from './acceptance.models';

export type AcceptancePreset = 'user' | 'referrer';

/**
 * Crea un Acceptance según el preset indicado.
 * - 'user': privacy + tos activados. Si se pasa refId, añade ref a 'users'.
 * - 'referrer': referrer activado con ref a 'piggytransactions'.
 * overrides permite ajustar campos puntuales (ej. ads).
 */
export function createAcceptance(preset: AcceptancePreset, refId?: string, overrides?: Partial<Acceptance>): Acceptance {
  const base = { privacy: null, tos: null, referrer: null, ads: null, printProtected: null } as Acceptance;

  switch (preset) {
    case 'user':
      base.privacy = true;
      base.tos = true;
      if (refId) base.ref = { id: refId, col: 'users' };
      break;
    case 'referrer':
      base.referrer = true;
      base.ref = { id: refId ?? '', col: 'piggytransactions' };
      break;
  }

  return { ...base, ...overrides } as Acceptance;
}

// Se usa en la creación del usuario
// Devuelve el usuario + el acceptance
export function setDefaultAcceptanceToUser(data: Partial<UserModel>) {
  // Le pasamos también el data.acceptance por si el usuario ya tiene algo en acceptance y queremos conservarlo
  // Si el usuario no tiene acceptance (data.acceptance = undefined), no se aplicará la operación de spread, de modo que
  // no alterará el funcionamiento de createAcceptance.
  data.acceptance = createAcceptance('user', null, data.acceptance);
  return data;
}
